import type { JSX, ReactNode } from "react"
import type { BannerCarrosselProps } from "../../banner-carrossel.props"
import { webPath } from "@/utils/webPath"

interface ContentBannerProps {
    banner: BannerCarrosselProps
    children: ReactNode
}

export function ContentBanner({ banner, children }: ContentBannerProps): JSX.Element {
    return (
        (banner.url || banner.produto?.link) ? (
            <a href={banner.automatico ? webPath(banner.produto.link) : webPath(banner.url)}>
                {children}
            </a>
        ) : (
            <>{children}</>
        )
    )
}
